(function() {
	"use strict";

	angular.module("swurveys.maker")
		.factory('authService', Handler)

	function Handler($q, localStoreService, $window, swurveyAdminService, swurveysStageConfig, $route, $templateCache, $interval, $location, loadingBannerService) {
		console.log("starting authservice");

		var credential;

		var deferred = $q.defer();

		var previousPath;

		var authService = {};

		var saveCurrentPath = authService.saveCurrentPath = function() {

			previousPath = $location.path();
		};

		var poolData = {
			UserPoolId: swurveysStageConfig.getConfigPropertyValue("user_pool_id"),
			ClientId: swurveysStageConfig.getConfigPropertyValue("user_pool_client_id")
		};

		var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);

		if (!credential) {
			credential = {
				"aws": {
					"cog_ip": swurveysStageConfig.getConfigPropertyValue("aws_cog_pool_id"),
					"assets": swurveysStageConfig.getConfigPropertyValue("assets_endpoint")
				}
			};

			credential.swurveys = {
				authProvider: function() {
					if (localStoreService.getItem('swurveys_auth'))
						return localStoreService.getItem('swurveys_auth').provider;
				},
				authToken: function() {
					if (localStoreService.getItem('swurveys_auth'))
						return localStoreService.getItem('swurveys_auth').token;
				},
				identityId: function() {
					if (localStoreService.getItem('swurveys_auth'))
						return localStoreService.getItem('swurveys_auth').identityId;
				},
				userProfile: function() {
					return localStoreService.getItem('swurveys_user');
				}
			};

			credential.isLoggedIn = function() {
				return AWS.config.credentials && AWS.config.credentials.accessKeyId && !AWS.config.credentials.expired;
			};

			credential.flush = function() {
				localStoreService.removeItem('swurveys_auth');
				localStoreService.removeItem('swurveys_user');

				if (AWS.config.credentials)
				AWS.config.credentials.accessKeyId = null;


				// Flush template cache
				var currentPageTemplate = $route.current.templateUrl;
				$templateCache.remove(currentPageTemplate);
				$route.reload();
			};

			credential.saveUser = function(name, email, provider) {
				localStoreService.setItem('swurveys_user', {
					name: name,
					email: email,
					provider: provider
				});
			};

			credential.getUser = function() {
				return localStoreService.getItem('swurveys_user');
			};

			credential.saveIdentity = function(provider, token, identityId) {
				localStoreService.setItem('swurveys_auth', {
					provider: provider,
					token: token,
					identityId: identityId
				});
			};
		}

		var loginSmooch = function(user) {
			var uid = user.userId;

			if(typeof(Smooch) != 'undefined' && Smooch.login) Smooch.login(uid, {
				email: user.email,
				givenName: user.name,
				properties: {
					stripeLink: "https://dashboard.stripe.com/customers/" + uid,
					dashboardLink: "https://app.swurveys.com/designer.html#/d/" + uid
				}
			});

		};



		var refreshUserPoolToken = function(provider, callback) {
			console.log("refresh", provider, callback);
			var cognitoUser = userPool.getCurrentUser();
			console.log(cognitoUser);

			if (!cognitoUser) {
				console.log("ERROR! We should have a refresh token");
				credential.flush();
				return $location.path("/l");
			}
			cognitoUser.getSession(function(err, session) {
				console.log(err, session);
				if (!session.isValid()) {
					console.log("user pool session no longer valid");
					return $location.path("/l");
				}
				var accessToken = session.getIdToken().getJwtToken();

				if (!AWS.config.credentials) {
					AWS.config.credentials = new AWS.CognitoIdentityCredentials({
						IdentityPoolId: credential.aws.cog_ip,
						Logins: {}
					});

				}
				AWS.config.credentials.params.Logins[provider] = accessToken;
				if (callback) {
					callback(accessToken);
				}
			});
		};

		var exchangeToken =
			authService.exchangeToken = function(provider, token, callback) {

				if (!token)
					throw new Error("missing token parameter");


				var params = {
					IdentityPoolId: credential.aws.cog_ip,
					Logins: {}
				};

				params.Logins[provider] = token;

				console.log(params);

				AWS.config.credentials = new AWS.CognitoIdentityCredentials(params);
				AWS.config.credentials.clearCachedId();

				AWS.config.credentials.refresh(function() {

					var identityId = AWS.config.credentials.identityId;

					console.log(AWS.config.credentials);

					if (AWS.config.credentials.expired) {
						if (callback) {
							callback("Credentials Expired");
						}
						return;
					}

					credential.saveIdentity(provider, token, identityId);

					swurveyAdminService.login(
							identityId,
							provider,
							token
						)
						.then(
							function(swurveysData) {

								credential.user = swurveysData.user;
								var refreshToken = swurveysData.user.refreshToken;

								if (refreshToken && provider == "graph.facebook.com") {
									credential.saveIdentity(provider, refreshToken.token, identityId);
								}

								if (provider.startsWith("cognito-idp")) {
									//Cognito just gives us a refresh token, so let's use it.
									$interval(function() {
										refreshUserPoolToken(provider);
									}, 1800000); //every 30 min
								}

								loginSmooch(credential.user);


								if (callback) {
									callback();
								}
							},
							function(err) {
								if (err.name === 'NetworkingError') {
									loadingBannerService.hide();
									$location.path('/error');
								}
								else {
									authService.relogin();
								}
								if (callback) {
									callback(err);
								}
							});

				});
			};

		//*// AWS ////////////////////////////////////////
		AWS.config.region = "us-east-1";

		//*// AWS ////////////////////////////////////////


		//*// GOOGLE ///////////////////////////////////
		//We have to register our callbacks before we load the scripts
		//We can't include scripts inline in the html, even deferred, because the SDK may load before we get to this point
		window.googAsyncInit = function() {
			gapi.load("auth2", function() {
				gapi.auth2.init({
					client_id: swurveysStageConfig.getConfigPropertyValue("google_client_id"),
					cookiepolicy: "single_host_origin"
				});
				credential.gAuth = gapi.auth2.getAuthInstance();
			});
		};

		var po = document.createElement('script');
		po.type = 'text/javascript';
		po.async = true;
		po.src = 'https://apis.google.com/js/platform.js?onload=googAsyncInit';
		var s = document.getElementsByTagName('script')[0];
		s.parentNode.insertBefore(po, s);

		//*// GOOGLE ///////////////////////////////////

		//*// AMAZON ///////////////////////////////////
		window.onAmazonLoginReady = function() {
			amazon.Login.setClientId(swurveysStageConfig.getConfigPropertyValue("amazon_client_id"));
		};

		var po = document.createElement('script');
		po.type = 'text/javascript';
		po.async = true;
		po.src = 'https://api-cdn.amazon.com/sdk/login1.js';
		var s = document.getElementsByTagName('script')[0];
		s.parentNode.insertBefore(po, s);
		//*// AMAZON ///////////////////////////////////

		authService.getPreviousPath = function() {
			return previousPath;
		};


		
		authService.logOut = function() {
			var cognitoUser = userPool.getCurrentUser();
			if(cognitoUser)
			{
				cognitoUser.signOut();
				console.log("userPool user signed out");
			}

			authService.relogin();

		}
		authService.relogin = function() {

			saveCurrentPath();

			var message = "Sign-in with your email address or favorite social network";


			if (credential.getUser()) {
				//This device has logged in before
				message = "Please relogin. Your session has expired.";

			}
			credential.flush();

			var freeStyle = $("style#free-style")[0].sheet;

			freeStyle.disabled = true;

			//TODO: Find better solution
			//HACK: If the user is comming from a public analytics
			//			page then display a custom message.
			// We can inject the StateParams here and check for it!

			if ($location.path().indexOf('public') !== -1) {

				message = "Sign-in to See All Results";
			}
			else if ($location.search().message) {
				message = $location.search().message;
			}

			$location.path("/l").search({
				message: message
			});
		};


		console.log("setting credential");
		authService.async = function() {

			return deferred.promise;
		};

		if (!AWS.config.credentials) {

			var provider = credential.swurveys.authProvider();
			var token = credential.swurveys.authToken();

			console.log("Re-auth via AWS via: ", provider);
			if (provider && provider.startsWith("cognito-idp")) {
				//Let's attempt to reauth
				refreshUserPoolToken(provider, function(accessToken) {
					exchangeToken(provider, accessToken, function() {
						console.log("Refreshed from userpool");
						deferred.resolve(credential);
					});
				});
			}
			else if (provider && token) {
				exchangeToken(provider, token, function() {
					console.log("EXCHANGE TOKEN");
					deferred.resolve(credential);
				});
			}
			else {
				deferred.resolve(credential);
			}

		}
		else {
			deferred.resolve(credential);
		}


		return authService;
	}

}());
